import FilterListIcon from '@mui/icons-material/FilterList'
import { Chip, IconButton, Stack, Typography } from '@mui/material'

const FilterHeader = ({ label, onClick, active, selectedCount }) => {
    return (
        <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography>{label}</Typography>
            <IconButton size="small" onClick={onClick}>
                <FilterListIcon
                    color={active && selectedCount > 0 ? 'primary' : 'inherit'}
                    fontSize="small" />
            </IconButton>
            {selectedCount > 0 && (
                <Chip size="small"
                    label={(selectedCount || 0)}
                    color="primary" />
            )}

        </Stack>
    )
}

export default FilterHeader
